import moment from 'moment'
import getStorage from '../Services/Storage'

const storageService = getStorage()

export const datetime = (...args) =>
  storageService.get('utcEnabled', false)
    ? moment(...args).utc()
    : moment(...args)

// mui 5 datetime picker does not have a timezone option
// so time is always considered as local time, but when wee
// use it with the utc enabled option active, we actually want
// the selected time to be considered UTC
export const datetimeInput = (date, reverse = false) => {
  return storageService.get('utcEnabled', false)
    ? moment(date).add(moment(date).utcOffset() * (reverse ? -1 : 1), 'minutes')
    : moment(date)
}

// date pickers return a local Date: what the user picked is its calendar day, which must be
// interpreted in the active timezone (not converted as an instant, which could shift it by one day)
export const startOfPickedDay = (value) => {
  const date = new Date(value)
  const day = [date.getFullYear(), date.getMonth(), date.getDate()]
  return storageService.get('utcEnabled', false) ? moment.utc(day) : moment(day)
}

export const endOfPickedDay = (value) => startOfPickedDay(value).endOf('day')

export const hasSameYear =(date1, date2) => {
  if (!date2) return true
  const dt1 = new Date(date1)
  const dt2 = new Date(date2)
  return (
    dt1.getFullYear() === dt2.getFullYear() && dt1.getMonth() === dt2.getMonth()
  )
}

export const msToHours = ms => ms / (1000 * 60 * 60)
